import { sideBarItem } from '@/components/Sidebar/constants';
import { useApi, useCaller } from '@/hooks/api.hook';
import { setListSidebarAction, setSidebarErrorAction } from '@/redux/slicers/sidebar.slice';
import { SidebarType } from '@/types/sidebar';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

// Toggle this to use fake data when API is down
const USE_MOCK_DATA = false;
export const useSidebarByRole = () => {
  const api = useApi('');
  const caller = useCaller();
  const dispatch = useDispatch();

  const getSidebarByRole = useCallback(async () => {
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 300));
      const mockSidebar: SidebarType[] = [
        {
          label: 'Customer',
          order: 1,
          menus: sideBarItem,
        },
      ];
      dispatch(setListSidebarAction({ data: mockSidebar }));
      return mockSidebar;
    }

    const response = await caller(() => api.get(`/api/v1/menus`), {
      loadingKey: 'get-sidebar-by-role',
    });

    if (response?.succeeded) {
      const sidebarData = response.content?.navigation || response.content || [];
      dispatch(setListSidebarAction({ data: Array.isArray(sidebarData) ? sidebarData : [] }));
      return sidebarData;
    }

    // API failed → set error state
    dispatch(setSidebarErrorAction());
    return null;
  }, [caller, api, dispatch]);

  return {
    getSidebarByRole,
  };
};
